import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodmenuService } from 'src/app/services/addfoodmenu.service';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { RemovemodalmenuComponent } from 'src/app/modal/remove-modal-menu/remove-modal-menu.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-list-food-menu',
  templateUrl: './list-food-menu.component.html',
  styleUrls: ['./list-food-menu.component.scss']
})
export class ListFoodMenuComponent implements OnInit {

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  vendorId: any;
  prakList: any = [];
  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  showDropdown: boolean = false;
  totalCount;
  displayCount;
  mainMenuList: any[] = [];
  newmainMenuList: any[] = [];
  menusDeepCopy: any;
  newMainMenus: any;
  menusTempNew: any;
  masterSelectedMenus: boolean;
  checkedMenusList: any;
  checkedOnlyMenusList: any;
  formatToDate: any;
  menuStartDate: any;
  menuEndDate: any;
  formatDate: any;
  selectedDate: any;
  selectedToDate: any;
  tempDate: any;
  selectedMenuName: any;
  selectedMenuAvailableName: any;
  selectedMenuCuisinneName: any;
  mainMenuTypes = [];
  mainMenuAvailableTypes = [];
  mainMenuCuissineTypes = [];
  searchGroup: string = '';
  multiSelectGroupType: any;
  searchMenuList = [];
  searchMenuListAva = [];
  searchMenuListCuis = [];
  formattedSelectedDate: string = '';
  formattedSelectedToDate: string = '';
  fromDate: any;
  fDate: any;
  toDate: any;
  tDate: string;
  isDesc: boolean = false;
  column: string = 'menuValidFrom';
  searchMenuListDate = [];
  mainMenuLatestTypes = [];
  selectedCouponSortName: any;
  searchGroupSort: string = '';
  searchGroupSortAva: string = '';
  searchGroupCus: string = '';
  multiSelectGroupAva: any;
  multiSelectGroupCuis: any;
  onlyMenuIds = [];
  fromListPage = 'yes';
  toDateModified: any;
  newMonth: any;
  newDay: any;
  newMonthFrom: any;
  newDayFrom: any;
  fromDateModified: any;
  vendorName: any;
  deletedMenuId = [];
  foodvendorRemove: any;
  foodvendorEdit: any;
  foodvendorCreate: any;
  foodvendorView: any;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodmenuService: AddfoodmenuService,
    private foodcourtmenuService: FoodcourtmenuService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    this.foodvendorRemove = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Remove');
    this.foodvendorEdit = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Edit');
    this.foodvendorCreate = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Create');
    this.foodvendorView = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:View');
    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    this.vendorName = localStorage.getItem('vendor_name');
    localStorage.setItem('vendor_id', this.vendorId);

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    this.getMainMenuTypeList();
    this.getMainMenuAvailableList();
    this.getMainMenuCuissineList();
    this.getTheMenusList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.foodcourtmenuService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverSort(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverAvailable(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverCuissine(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openModal(onlyMenuIds: string, fromListPage: any): void {

    this.deletedMenuId = [];
    this.deletedMenuId.push({
      "foodCourtVendorMenuIds": this.onlyMenuIds,
    });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalmenuComponent, modalOptions);
    // modalRef.componentInstance.menuId = this.deletedMenuId[0];
    modalRef.componentInstance.menuId = this.onlyMenuIds;
    modalRef.componentInstance.fromDetailsPage = 'no';
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      if (this.multiSelectGroupType == 'All' || this.multiSelectGroupAva == 'All' || this.multiSelectGroupCuis == 'All') {
        this.newmainMenuList = this.mainMenuList;
      } else {
        if (this.searchMenuList.length > 0) {
          this.newmainMenuList = this.searchMenuList;
        } else if (this.searchMenuListAva.length > 0) {
          this.newmainMenuList = this.searchMenuListAva;
        } else if (this.searchMenuListCuis.length > 0) {
          this.newmainMenuList = this.searchMenuListCuis;
        } else {
          this.newmainMenuList = this.mainMenuList;
        }
      }
      this.totalRows = this.newmainMenuList?.length;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    let sourceList: any[] = [];

    if (this.searchMenuList.length > 0) {
      sourceList = this.searchMenuList;
    } else if (this.searchMenuListAva.length > 0) {
      sourceList = this.searchMenuListAva;
    } else if (this.searchMenuListCuis.length > 0) {
      sourceList = this.searchMenuListCuis;
    } else {
      sourceList = this.mainMenuList;
    }

    this.newmainMenuList = sourceList.filter((item: { foodName: any }) => {
      if (!item || !item.foodName) return false;
      return item.foodName.toLowerCase().includes(searchLower);
    });

    this.totalRows = this.newmainMenuList?.length;
  }

  getFilteredMenuTypes(): any[] {
    if (!this.mainMenuTypes || !Array.isArray(this.mainMenuTypes)) {
      return [];
    }
    if (!this.searchGroupSort || this.searchGroupSort === '') {
      return this.mainMenuTypes;
    }
    const searchLower = this.searchGroupSort.toLowerCase();
    return this.mainMenuTypes.filter((item: any) => {
      if (!item || !item.menuTypeName) return false;
      return item.menuTypeName.toLowerCase().includes(searchLower);
    });
  }

  getFilteredMenuAvailableTypes(): any[] {
    if (!this.mainMenuAvailableTypes || !Array.isArray(this.mainMenuAvailableTypes)) {
      return [];
    }
    if (!this.searchGroupSortAva || this.searchGroupSortAva === '') {
      return this.mainMenuAvailableTypes;
    }
    const searchLower = this.searchGroupSortAva.toLowerCase();
    return this.mainMenuAvailableTypes.filter((item: any) => {
      if (!item || !item.menuAvaName) return false;
      return item.menuAvaName.toLowerCase().includes(searchLower);
    });
  }

  getFilteredMenuCuissineTypes(): any[] {
    if (!this.mainMenuCuissineTypes || !Array.isArray(this.mainMenuCuissineTypes)) {
      return [];
    }
    if (!this.searchGroupCus || this.searchGroupCus === '') {
      return this.mainMenuCuissineTypes;
    }
    const searchLower = this.searchGroupCus.toLowerCase();
    return this.mainMenuCuissineTypes.filter((item: any) => {
      if (!item || !item.menuCuiName) return false;
      return item.menuCuiName.toLowerCase().includes(searchLower);
    });
  }

  handelMenuList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  goToMenuDetails(id) {
    this.router.navigate(['/menu-details/' + id]);
  }

  checkUncheckAll() {
    for (var i = 0; i < this.mainMenuList.length; i++) {
      this.mainMenuList[i].isSelected = this.masterSelectedMenus;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedMenus);
    if (this.masterSelectedMenus === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedMenus = this.mainMenuList.every(function (item: any) {
      return item.isSelected === true;
    });
    console.log(this.masterSelectedMenus);
    this.getCheckedItemList();
  }

  getCheckedItemList() {

    this.checkedMenusList = [];
    this.checkedOnlyMenusList = [];
    this.onlyMenuIds = [];

    for (var i = 0; i < this.mainMenuList?.length; i++) {

      if (this.mainMenuList[i].isSelected) {

        this.checkedMenusList.push(this.mainMenuList[i]);
        this.checkedOnlyMenusList.push(this.mainMenuList[i]);

        this.showDropdown = true;
      }
    }

    for (var j = 0; j < this.checkedOnlyMenusList?.length; j++) {
      this.onlyMenuIds.push(this.checkedOnlyMenusList[j].foodCourtVendorMenuId);
    }

    console.log(this.onlyMenuIds);
    this.checkedMenusList = JSON.stringify(this.checkedMenusList);

  }

  getTheMenusList() {

    const userListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.foodcourtmenuService.getMenuListByVendor(this.vendorId).subscribe((res) => {
      if (res?.isValid === true) {
        this.mainMenuList = res?.list;

        this.mainMenuList.forEach(item => {
          if (item.isAvailable === true) {
            item.isAvailable = "Available";
          } else if (item.isAvailable === false) {
            item.isAvailable = "Not Available";
          }
        });

        console.log(this.mainMenuList);

        this.newmainMenuList = res?.list;

        this.newmainMenuList.forEach(item => {
          if (item.isAvailable === true) {
            item.isAvailable = "Available";
          } else if (item.isAvailable === false) {
            item.isAvailable = "Not Available";
          }
        });

        console.log(this.newmainMenuList);
        this.newMainMenus = res;
        this.menusDeepCopy = JSON.parse(JSON.stringify(res));
        this.menusTempNew = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainMenuList = [];
        this.newmainMenuList = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.mainMenuList?.length; i++) {
      this.mainMenuList[i].isSelected = false;
    }

    console.log(this.mainMenuList);

    this.getCheckedItemList();
  }

  getMainMenuTypeList() {

    this.mainMenuTypes.push({
      menuTypeId: "Veg",
      menuTypeName: "Veg"
    },
      {
        menuTypeId: "Non-Veg",
        menuTypeName: "Non-Veg"
      }
    );
    const allOpt = {
      menuTypeId: null,
      menuTypeName: "All"
    }
    this.mainMenuTypes.unshift(allOpt);
    this.selectedMenuName = this.mainMenuTypes[0].menuTypeName;
  }

  getMainMenuAvailableList() {

    this.mainMenuAvailableTypes.push({
      menuAvaId: "Available",
      menuAvaName: "Available"
    },
      {
        menuAvaId: "Not Available",
        menuAvaName: "Not Available"
      }
    );
    const allOpt = {
      menuAvaId: null,
      menuAvaName: "All"
    }
    this.mainMenuAvailableTypes.unshift(allOpt);
    this.selectedMenuAvailableName = this.mainMenuAvailableTypes[0].menuAvaName;
  }

  getMainMenuCuissineList() {

    this.mainMenuCuissineTypes.push(
      {
        menuCuiId: "Indian",
        menuCuiName: "Indian"
      },
      {
        menuCuiId: "North Indian",
        menuCuiName: "North Indian"
      },
      {
        menuCuiId: "Continental",
        menuCuiName: "Continental"
      },
      {
        menuCuiId: "Italian",
        menuCuiName: "Italian"
      },
      {
        menuCuiId: "Chinese",
        menuCuiName: "Chinese"
      },
      {
        menuCuiId: "Japanese",
        menuCuiName: "Japanese"
      },
      {
        menuCuiId: "Thai",
        menuCuiName: "Thai"
      },
      {
        menuCuiId: "Korean",
        menuCuiName: "Korean"
      },
      {
        menuCuiId: "American",
        menuCuiName: "American"
      },
      {
        menuCuiId: "Mexican",
        menuCuiName: "Mexican"
      },
      {
        menuCuiId: "International",
        menuCuiName: "International"
      }
    );
    const allOpt = {
      menuCuiId: null,
      menuCuiName: "All"
    }
    this.mainMenuCuissineTypes.unshift(allOpt);
    this.selectedMenuCuisinneName = this.mainMenuCuissineTypes[0].menuCuiName;
  }

  selectMenuType(item) {

    console.log(item);

    this.selectedMenuName = item.menuTypeName;

    if (item.menuTypeName !== null) {
      if (this.multiSelectGroupType == item.menuTypeName) {
        this.multiSelectGroupType.splice(this.multiSelectGroupType.indexOf(item.menuTypeName), 1);
      } else {
        this.newMainMenus.list = this.menusDeepCopy.list;
        this.multiSelectGroupType = item.menuTypeName;
      }
    }
    else {
      this.multiSelectGroupType = 'All';
    }

    console.log(this.multiSelectGroupType);

    if (this.multiSelectGroupType != '') {
      if (this.multiSelectGroupType == 'All') {
        if (this.searchMenuListAva.length > 0) {
          this.newmainMenuList = this.searchMenuListAva;
        } else if (this.searchMenuListCuis.length > 0) {
          this.newmainMenuList = this.searchMenuListCuis;
        } else {
          // this.newmainMenuList = this.menusDeepCopy.list;
          this.newmainMenuList = this.mainMenuList.filter((item) => {
            return item.foodCourtVendorMenuId != '';
          });
        }
      } else {
        if (this.searchMenuListAva.length > 0) {
          this.newmainMenuList = this.searchMenuListAva.filter((item) => {
            return item.foodType == this.multiSelectGroupType;
          });
        } else if (this.searchMenuListCuis.length > 0) {
          this.newmainMenuList = this.searchMenuListCuis.filter((item) => {
            return item.foodType == this.multiSelectGroupType;
          });
        } else {
          this.newmainMenuList = this.mainMenuList.filter((item) => {
            return item.foodType == this.multiSelectGroupType;
          });
        }
      }
    } else {
      this.newmainMenuList = this.menusDeepCopy.list;
    }

    this.searchMenuList = this.newmainMenuList;

    this.totalRows = this.newmainMenuList.length;
    this.totalCount = this.newmainMenuList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    if (this.multiSelectGroupType != '') {
      this.selectedMenuName = this.mainMenuList.filter(group => group.foodType === this.multiSelectGroupType)[0].foodType;
    } else {
      this.selectedMenuName = this.mainMenuList[0].foodType;
    }
  }

  selectMenuAvaType(item) {

    console.log(item);

    this.selectedMenuAvailableName = item.menuAvaName;

    if (item.menuAvaName !== null) {
      if (this.multiSelectGroupAva == item.menuAvaName) {
        this.multiSelectGroupAva.splice(this.multiSelectGroupAva.indexOf(item.menuAvaName), 1);
      } else {
        this.newMainMenus.list = this.menusDeepCopy.list;
        this.multiSelectGroupAva = item.menuAvaName;
      }
    }
    else {
      this.multiSelectGroupAva = 'All';
    }

    console.log(this.multiSelectGroupAva);

    if (this.multiSelectGroupAva != '') {
      if (this.multiSelectGroupAva == 'All') {
        if (this.searchMenuList.length > 0) {
          this.newmainMenuList = this.searchMenuList;
        } else if (this.searchMenuListCuis.length > 0) {
          this.newmainMenuList = this.searchMenuListCuis;
        } else {
          // this.newmainMenuList = this.menusDeepCopy.list;
          this.newmainMenuList = this.mainMenuList.filter((item) => {
            return item.foodCourtVendorMenuId != '';
          });
        }
      } else {
        if (this.searchMenuList.length > 0) {
          this.newmainMenuList = this.searchMenuList.filter((item) => {
            return item.isAvailable == this.multiSelectGroupAva;
          });
        } else if (this.searchMenuListCuis.length > 0) {
          this.newmainMenuList = this.searchMenuListCuis.filter((item) => {
            return item.isAvailable == this.multiSelectGroupAva;
          });
        } else {
          this.newmainMenuList = this.mainMenuList.filter((item) => {
            return item.isAvailable == this.multiSelectGroupAva;
          });
        }
      }
    } else {
      this.newmainMenuList = this.menusDeepCopy.list;
    }

    this.searchMenuListAva = this.newmainMenuList;

    this.totalRows = this.newmainMenuList.length;
    this.totalCount = this.newmainMenuList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    if (this.multiSelectGroupAva != '') {
      this.selectedMenuAvailableName = this.mainMenuList.filter(group => group.isAvailable === this.multiSelectGroupAva)[0].isAvailable;
    } else {
      this.selectedMenuAvailableName = this.mainMenuList[0].isAvailable;
    }
  }

  selectMenuCuissineType(item) {

    console.log(item);

    this.selectedMenuCuisinneName = item.menuCuiName;

    if (item.menuCuiName !== null) {
      if (this.multiSelectGroupCuis == item.menuCuiName) {
        this.multiSelectGroupCuis.splice(this.multiSelectGroupCuis.indexOf(item.menuCuiName), 1);
      } else {
        this.newMainMenus.list = this.menusDeepCopy.list;
        this.multiSelectGroupCuis = item.menuCuiName;
      }
    }
    else {
      this.multiSelectGroupCuis = 'All';
    }

    if (this.multiSelectGroupCuis != '') {
      if (this.multiSelectGroupCuis == 'All') {
        if (this.searchMenuList.length > 0) {
          this.newmainMenuList = this.searchMenuList;
        } else if (this.searchMenuListAva.length > 0) {
          this.newmainMenuList = this.searchMenuListAva;
        } else {
          // this.newmainMenuList = this.menusDeepCopy.list;
          this.newmainMenuList = this.mainMenuList.filter((item) => {
            return item.foodCourtVendorMenuId != '';
          });
        }
      } else {
        if (this.searchMenuList.length > 0) {
          this.newmainMenuList = this.searchMenuList.filter((item) => {
            return item.foodCuisine == this.multiSelectGroupCuis;
          });
        } else if (this.searchMenuListAva.length > 0) {
          this.newmainMenuList = this.searchMenuListAva.filter((item) => {
            return item.foodCuisine == this.multiSelectGroupCuis;
          });
        } else {
          this.newmainMenuList = this.mainMenuList.filter((item) => {
            return item.foodCuisine == this.multiSelectGroupCuis;
          });
        }
      }
    } else {
      this.newmainMenuList = this.menusDeepCopy.list;
    }

    this.searchMenuListCuis = this.newmainMenuList;

    this.totalRows = this.newmainMenuList.length;
    this.totalCount = this.newmainMenuList.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);

    if (this.multiSelectGroupCuis != '') {
      this.selectedMenuCuisinneName = this.mainMenuList.filter(group => group.foodCuisine === this.multiSelectGroupCuis)[0].foodCuisine;
    } else {
      this.selectedMenuCuisinneName = this.mainMenuList[0].foodCuisine;
    }
  }

  goToAddNewMenuItem() {
    this.router.navigate(['/add-food-menu/' + this.vendorId]);
  }

  goToBulkUploadPage() {
    this.router.navigate(['/food-menu-bulk-upload/' + this.vendorId]);
  }

}
